export default "__VITE_ASSET__3a02e61e__"